import React from "react";
import PropTypes from 'prop-types';
import Properties from "./Properties";
import MenuItems from "./MenuItems";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        width: '100%',
        height: '100%'
    },
    menuItemsContainer: {
        width: '50%',
        borderRight: "1px solid #e8e8e8",
        height: '100%',
        overflow: 'hidden'
    },
    menuItems: {
        width: '100%',
        height: '95%',
        overflow: 'auto',
        padding: 15
    },
    propertiesContainer: {
        width: '50%',
        height: '100%',
        overflow: 'hidden'
    },
    properties: {
        width: '100%',
        height: '95%',
        overflow: 'auto',
        padding: 15
    },
    sideTitle: {
        background: "#f7f7f7"
    }
}));

const MenuItemsProperties = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.menuItemsContainer}>
                <div className={classes.sideTitle}>
                    <Typography color={"textSecondary"} align={"center"}>
                        Items
                    </Typography>
                    <Divider/>
                </div>
                <div className={classes.menuItems}>
                    <MenuItems/>
                </div>
            </div>
            <div className={classes.propertiesContainer}>
                <div className={classes.sideTitle}>
                    <Typography color={"textSecondary"} align={"center"}>Properties</Typography>
                    <Divider/>
                </div>
                <div className={classes.properties}>
                    <Properties/>
                </div>
            </div>
        </div>
    )
};

export default MenuItemsProperties

MenuItemsProperties.propTypes = {
    menu: PropTypes.array,
    selectedItem: PropTypes.object,
    setValue: PropTypes.func,
    selectItem: PropTypes.func
};